import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  styled,
} from "@mui/material";
import { RichText, toPlainText } from "../../../components/RichText";

interface WhatCanIDoDialogProps {
  open: boolean;
  onClose: () => void;
  richTextContent?: unknown;
}

const AskIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M62.8452 0.9375H24.8005C24.6806 0.9375 24.5835 1.0347 24.5835 1.1546V28.4223C24.5835 28.5422 24.6806 28.6393 24.8005 28.6393H35.4511C35.5709 28.6393 35.6681 28.7364 35.6681 28.8563V36.361C35.6681 36.5543 35.9017 36.6511 36.0385 36.5144L43.85 28.7029C43.8908 28.6623 43.9459 28.6394 44.0034 28.6394H62.8453C62.9652 28.6394 63.0623 28.5423 63.0623 28.4224V1.1544C63.0622 1.0347 62.9651 0.9375 62.8452 0.9375Z"
      fill="#FCEE56"
    />
    <path
      d="M62.8452 0.9375H58.062V17.6482C58.062 22.3377 54.2605 26.1392 49.571 26.1392H24.5835V28.4223C24.5835 28.5422 24.6806 28.6393 24.8005 28.6393H35.4511C35.5708 28.6393 35.6681 28.7364 35.6681 28.8562V36.3609C35.6681 36.5541 35.9017 36.6509 36.0385 36.5142L43.85 28.7028C43.8907 28.6621 43.9459 28.6393 44.0034 28.6393H62.8453C62.9652 28.6393 63.0623 28.5422 63.0623 28.4223V1.1544C63.0622 1.0347 62.9651 0.9375 62.8452 0.9375Z"
      fill="#FBE709"
    />
    <path
      d="M1.5223 27.7346C3.6191 26.5223 6.3015 27.2404 7.5124 29.3377L8.4457 30.9543V15.6631C8.4457 14.1283 9.69 12.8842 11.2247 12.8842C12.7595 12.8842 14.0037 14.1283 14.0037 15.6631V12.345C14.0037 10.8102 15.2479 9.566 16.7827 9.566C18.3175 9.566 19.5617 10.8102 19.5617 12.345V15.6631C19.5617 14.1025 20.8483 12.8422 22.4188 12.8853C23.9325 12.9268 25.1196 14.2067 25.1196 15.721V19.376C25.1196 17.8412 26.3638 16.5971 27.8986 16.5971C29.4334 16.5971 30.6776 17.8412 30.6776 19.376V39.0987C30.6776 41.6671 29.8066 44.0321 28.3438 45.9143C27.4349 47.0838 26.9511 48.5277 26.951 50.0091L26.9506 62.9371C26.9506 63.0065 26.8943 63.0627 26.825 63.0627H12.2984C12.229 63.0627 12.1727 63.0065 12.1727 62.9371L12.1722 50.0073C12.172 48.5344 11.7 47.0932 10.7938 45.932C10.4092 45.4392 10.0653 44.9132 9.767 44.3589L1.0948 29.3378C0.771 28.7772 0.9619 28.0588 1.5223 27.7346Z"
      fill="#FFCBBE"
    />
    <path
      d="M30.6775 19.376C30.6775 17.8411 29.4333 16.597 27.8985 16.597C26.9906 16.597 26.1844 17.0323 25.6773 17.7057V36.5985C25.6773 39.1669 24.8063 41.5318 23.3433 43.414C22.4344 44.5836 21.9508 46.0275 21.9505 47.5088L21.9504 53.2202C21.9503 57.2752 18.663 60.5624 14.608 60.5624H12.1727L12.1729 62.937C12.1729 63.0063 12.2291 63.0625 12.2985 63.0625H26.8248C26.8942 63.0625 26.9505 63.0062 26.9505 62.937L26.9508 50.009C26.951 48.5277 27.4346 47.0837 28.3436 45.9141C29.8065 44.0319 30.6776 41.667 30.6776 39.0986L30.6775 19.376Z"
      fill="#FDAD9D"
    />
    <path
      d="M45.0171 18.0684C45.0171 17.6598 45.2923 17.3 45.6864 17.1927C48.4902 16.4305 50.3797 13.7674 50.1792 10.8601C49.9707 7.8371 47.5341 5.4005 44.5112 5.192C42.796 5.0745 41.1602 5.652 39.908 6.8208C38.6731 7.9736 37.9648 9.603 37.9648 11.2917C37.9648 11.8096 38.3844 12.2293 38.9023 12.2293C39.4202 12.2293 39.8399 11.8096 39.8399 11.2917C39.8399 10.1037 40.3184 9.0026 41.1874 8.1916C42.0555 7.3813 43.1901 6.98 44.3822 7.0627C46.4761 7.207 48.1641 8.895 48.3085 10.989C48.4476 13.007 47.138 14.8551 45.1946 15.3833C43.9859 15.7118 43.1419 16.8158 43.1419 18.0682V19.9199C43.1419 20.4378 43.5615 20.8575 44.0794 20.8575C44.5973 20.8575 45.017 20.4378 45.017 19.9199L45.0171 18.0684Z"
      fill="#1C252E"
    />
    <path
      d="M44.0635 24.3137C44.5813 24.3137 45.001 23.8939 45.001 23.3762C45.001 22.8584 44.5813 22.4387 44.0635 22.4387C43.5457 22.4387 43.126 22.8584 43.126 23.3762C43.126 23.8939 43.5457 24.3137 44.0635 24.3137Z"
      fill="#1C252E"
    />
    <path
      d="M62.8452 0H24.8005C24.1639 0 23.6461 0.518 23.6461 1.1544V3.0548C23.6461 3.5727 24.0657 3.9923 24.5836 3.9923C25.1015 3.9923 25.5212 3.5727 25.5212 3.0548V1.8751H62.1247V27.7016H44.0033C43.6943 27.7016 43.4041 27.8221 43.187 28.0398L36.6056 34.6212V28.8562C36.6056 28.2195 36.0877 27.7018 35.4512 27.7018H31.6152V19.376C31.6152 17.3266 29.9478 15.6595 27.8986 15.6595C27.2291 15.6595 26.6003 15.8375 26.0573 16.1485C26.0333 15.929 26.1974 14.9152 25.5213 13.7826V8.6801C25.5213 8.1622 25.1016 7.7426 24.5837 7.7426C24.0658 7.7426 23.6462 8.1622 23.6462 8.6801V12.19C23.2701 12.0444 22.8657 11.9597 22.4447 11.9481C21.7533 11.9289 21.0841 12.098 20.4993 12.4329V12.345C20.4993 10.2957 18.8321 8.6285 16.7829 8.6285C14.7337 8.6285 13.0664 10.2958 13.0664 12.345V12.4358C12.5232 12.1247 11.8946 11.9467 11.2251 11.9467C9.1757 11.9467 7.5085 13.6139 7.5085 15.6631V18.2157C7.5085 18.7336 7.9282 19.1533 8.4461 19.1533C8.964 19.1533 9.3836 18.7336 9.3836 18.2157V15.6631C9.3836 14.6479 10.2097 13.8218 11.2251 13.8218C12.2404 13.8218 13.0664 14.6479 13.0664 15.6631V28.12C13.0664 28.6379 13.486 29.0576 14.0039 29.0576C14.5218 29.0576 14.9415 28.6379 14.9415 28.12V12.345C14.9415 11.3296 15.7675 10.5036 16.7829 10.5036C17.7982 10.5036 18.6242 11.3296 18.6242 12.345V28.12C18.6242 28.6379 19.0439 29.0576 19.5618 29.0576C20.0797 29.0576 20.4993 28.6379 20.4993 28.12V15.6631C20.4993 14.6252 21.3547 13.7928 22.393 13.8224C23.3797 13.8496 24.1821 14.7011 24.1821 15.721V28.12C24.1821 28.6379 24.6017 29.0576 25.1196 29.0576C25.6375 29.0576 26.0572 28.6379 26.0572 28.12V19.376C26.0572 18.3606 26.8832 17.5346 27.8985 17.5346C28.9139 17.5346 29.74 18.3606 29.74 19.376V39.0986C29.74 41.3824 29.0012 43.5402 27.6032 45.3389C26.5781 46.6579 26.0133 48.3164 26.0132 50.009L26.0128 62.1249H13.1104L13.1099 50.0072C13.1096 48.31 12.5496 46.6578 11.5331 45.3552C10.9409 44.5963 11.6028 45.6631 1.9067 28.8691C1.8414 28.7559 1.8794 28.6112 1.9917 28.5463C2.7887 28.0854 3.7175 27.9625 4.6073 28.2007C5.4967 28.4387 6.2401 29.0091 6.7005 29.8065C8.0518 32.1467 8.0057 32.067 9.3244 34.351C10.108 35.7081 11.5976 36.5184 13.1256 36.4131C15.5635 36.2475 17.58 38.1644 17.6576 40.497C17.7071 41.9761 17.0018 43.3497 15.7713 44.1716C15.3406 44.4592 15.2247 45.0413 15.5122 45.4719C15.7999 45.9025 16.382 46.0185 16.8126 45.7309C18.5862 44.5462 19.6027 42.5664 19.5317 40.4345C19.4193 37.0628 16.4999 34.303 12.9975 34.5424C12.1812 34.5979 11.3766 34.155 10.9482 33.4134L9.3832 30.703L9.3831 22.5908C9.3831 22.073 8.9634 21.6533 8.4456 21.6533C7.9277 21.6533 7.508 22.073 7.508 22.5908L7.5082 27.7934C6.8503 27.1235 6.0229 26.6386 5.0919 26.3895C3.7184 26.0216 2.284 26.2111 1.053 26.923C0.0462 27.5051 -0.2993 28.7987 0.2827 29.8066C9.8558 46.3503 9.2696 45.5025 10.0546 46.5087C10.8154 47.4834 11.2344 48.726 11.2347 50.0072L11.2352 62.937C11.2352 63.5231 11.712 64 12.2982 64H26.8247C27.41 64 27.8869 63.524 27.8879 62.937L27.8883 50.0091C27.8884 48.7311 28.3129 47.4812 29.0837 46.4895C30.7396 44.3587 31.6149 41.8031 31.6149 39.0986V29.5767H34.7303V36.3609C34.7303 36.8295 35.01 37.2482 35.4429 37.4274C35.8817 37.6092 36.3741 37.5042 36.7011 37.1773L44.3017 29.5767H62.8451C63.4817 29.5767 63.9995 29.0588 63.9995 28.4223V1.1544C63.9997 0.518 63.4818 0 62.8452 0Z"
      fill="#1C252E"
    />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9"
      stroke="#637381"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const StyledDialog = styled(Dialog, {
  label: "WhatCanIDoDialog",
})(() => ({
  "& .MuiDialog-paper": {
    borderRadius: 16,
    maxWidth: 420,
    width: "100%",
    boxShadow: "-40px 40px 80px -8px rgba(145, 158, 171, 0.24)",
  },
}));

const Heading = styled(Typography, {
  label: "WhatCanIDoHeading",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  fontSize: "24px",
  lineHeight: "36px",
  color: "#1C252E",
  textAlign: "center",
}));

const BodyText = styled(Typography, {
  label: "WhatCanIDoBody",
})(() => ({
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "28px",
  color: "#1C252E",
}));

export const WhatCanIDoDialog = ({
  open,
  onClose,
  richTextContent,
}: WhatCanIDoDialogProps) => {
  // Serialize rich text to JSON string (same pattern as HatInfo)
  const richTextValue =
    typeof richTextContent === "string"
      ? richTextContent
      : richTextContent
        ? JSON.stringify(richTextContent)
        : null;

  const hasContent = richTextValue && toPlainText(richTextValue);

  return (
    <StyledDialog open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          p: "12px 12px 0 24px",
        }}
      >
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          px: 3,
          pb: 2,
          pt: 0,
        }}
      >
        <AskIcon />
        <Heading>What can I do?</Heading>
        {hasContent ? (
          <Box sx={{ width: "100%" }}>
            <RichText value={richTextValue} />
          </Box>
        ) : (
          <BodyText>
            Explore related pathways and build skills that connect to this
            career!
          </BodyText>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          px: 3,
          py: 3,
        }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            backgroundColor: "#00A76F",
            textTransform: "none",
            fontFamily: "Proxima Nova, sans-serif",
            fontWeight: 700,
            fontSize: "14px",
            borderRadius: "8px",
            minWidth: 64,
            height: 36,
            "&:hover": {
              backgroundColor: "#007B55",
            },
          }}
        >
          Got it
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};
